import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose Tailwind class strings with `clsx` semantics and deduplicate
 * conflicting Tailwind utilities via `tailwind-merge`. The canonical class
 * helper for the entire app.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
